import { useTranslation } from 'react-i18next';
import { isLocale, type Locale } from '../locale';

/** The active UI locale (from the i18n instance, so components need no store access). */
export function useLocale(): Locale {
  const { i18n } = useTranslation();
  const lang = i18n.resolvedLanguage ?? i18n.language;
  return isLocale(lang) ? lang : 'en';
}
